import { useSyncExternalStore } from 'react';

// One shared ~30-second clock for the whole app, instead of a setInterval per
// component. Order cards use it to keep their "waiting X min / urgent" age
// current without each card owning its own timer — on a busy board (the New and
// Preparing columns are uncapped) that's the difference between one interval and
// dozens. The interval only runs while at least one subscriber is mounted.
const TICK_MS = 30_000;

const listeners = new Set<() => void>();
let now = Date.now();
let intervalId: number | null = null;

function subscribe(onChange: () => void): () => void {
  listeners.add(onChange);
  if (intervalId === null) {
    intervalId = window.setInterval(() => {
      now = Date.now();
      listeners.forEach((l) => l());
    }, TICK_MS);
  }
  return () => {
    listeners.delete(onChange);
    if (listeners.size === 0 && intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  };
}

function getSnapshot(): number {
  return now;
}

/**
 * Re-renders the caller about every 30 seconds off a single shared interval,
 * returning the current epoch-ms. For time-based UI (e.g. elapsed order age)
 * that must refresh on the clock, not on data changes.
 */
export function useNowTick(): number {
  return useSyncExternalStore(subscribe, getSnapshot);
}
